import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { classicProjectSettingsSoftwareProformaEditFormsRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-software-routes/src/classicProjectSettingsSoftwareProformaEditFormsRoute.tsx';
import { classicSoftwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';
import ProformaJiraFormBuilder, {
	LazyProjectSettingsProformaJiraFormBuilder,
} from './ui/project-settings/proforma-jira-form-builder/index.tsx';

export const classicProjectSettingsSoftwareProformaEditFormsRouteEntry = createEntry(
	classicProjectSettingsSoftwareProformaEditFormsRoute,
	() => ({
		group: 'project-settings-software',
		component: ProformaJiraFormBuilder,
		layout: classicSoftwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsProformaJiraFormBuilder],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsSoftwareProformaEditFormsRouteEntry.tsx',
				whichExportToUse: 'classicProjectSettingsSoftwareProformaEditFormsRouteEntry',
			},

			enabled: true,
		},
	}),
);
